import React from 'react';
export function ColombiaFlag({
  className = 'h-4 w-6'
}: {
  className?: string;
}) {
  return <span className={`inline-flex shrink-0 flex-col overflow-hidden rounded-[3px] ${className}`} aria-hidden="true" data-id="element-15" data-mp="2o6lppv59nma1">
      <span className="flex-[2] bg-[#fcd116]" data-id="element-16" data-mp="2jfdfiww43wvt" />
      <span className="flex-1 bg-[#003893]" data-id="element-17" data-mp="2je2bqx2o2p4p" />
      <span className="flex-1 bg-[#ce1126]" data-id="element-18" data-mp="2ei3q3h8q3l7z" />
    </span>;
}